export const SITE_URL: string = (import.meta.env.VITE_SITE_URL as string) ?? '';
